import React from "react";
import { connect } from "react-redux";

import { fetchData, patchData } from "../reducers/konditionen-reducer";
import { console } from '../utils/functions';
import { Preis, Kurs, Kondition } from './components';

class ConditionsItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      item: this.props.item,
      kondition: this.props.kondition,
      editMode: false
    };
    // bind event listeners to this
    this.changeKondition = this.changeKondition.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleCommit = this.handleCommit.bind(this);
    this.handleUndo = this.handleUndo.bind(this);
  }

  componentDidUpdate() {
    if (this.props.item.kennziffer !== this.state.item.kennziffer) {
      this.setState({ item: this.props.item, kondition: this.props.kondition, error: null });
    }
  }

  get locale() {
    return typeof this.props.locale === "string" ? this.props.locale : "de-DE";
  }

  get currency() {
    return typeof this.props.currency === "string" ? this.props.currency : "EUR";
  }

  handleEdit() {
    this.setState({ editMode: true, error: null });
    this.onChange({ editMode: true });
  }

  async handleCommit() {
    console.log("commit start");
    const item = this.state.item;
    const appType = this.props.aktiveKonditionen;
    const kondition = this.state.kondition;
    const col = kondition.col;
    if (!item.isDirty(col)) {
      console.log("commit not dirty");
      this.setState({ editMode: false });
      this.onChange({ editMode: false });
      return;
    }
    let listData = item.toJsonForUpdate(col);
    let konditionRequestData = this.props.configStorage.getRequestData(
      appType + "Konditionen",
      "post",
      listData
    );
    this.setState({ editMode: false, isFetching: true });
    this.onChange({ editMode: false });
    let result;
    result = await this.props.dispatch(patchData({ requestData: konditionRequestData, kennziffer: Number(item.kennziffer) }));
    console.log("patch", result);
    if (result.error) {
      console.error("k1", result.error);
      this.setState({ isFetching: false, error: result.error.message });
      return this.handleUndo();
    }
    konditionRequestData = this.props.configStorage.getRequestData(appType + "Konditionen");
    result = await this.props.dispatch(fetchData({ requestData: konditionRequestData, appType }));
    if (result.error) {
      console.error("k2", result.error);
      this.setState({ isFetching: false, error: result.error.message });
      return this.handleUndo();
    }
    console.log("fetch", result);
    const data = this.props.konditionenStorage.getItems();
    console.log("new data", data);
    const updatedItem = data.find(i => i.kennziffer === item.kennziffer);
    console.log(updatedItem && updatedItem.konditionen[col], kondition);
    if (updatedItem && updatedItem.konditionen[col] && updatedItem.konditionen[col].value === kondition.value) {
      const updateKondition = updatedItem.konditionen[col];
      this.setState({ item: updatedItem, kondition: updateKondition, isFetching: false, error: null });
      this.onChange({ item: updatedItem });
    } else {
      console.log("Konditionsänderung ist fehlgeschlagen");
      this.setState({ isFetching: false, error: "Konditionsänderung ist fehlgeschlagen" });
      this.handleUndo();
    }
  }

  handleUndo() {
    const item = this.state.item;
    const k = this.state.kondition;
    item.resetKondition(k.col);
    this.setState({ editMode: false, kondition: k });
    this.onChange({ editMode: false });
  }

  onChange(change) {
    if (typeof this.props.onChange === "function") this.props.onChange(change);
  }

  changeKondition({ value, col }) {
    console.log("changeKondition");
    let item = this.state.item;
    if (!item || isNaN(value) || isNaN(col)) return;
    item.setKondition(value, col);
    this.setState({ kondition: item.konditionen[col] });
  }

  render() {
    const item = this.state.item;
    const kondition = this.state.kondition;
    return <>
      <Kondition
        kondition={kondition}
        editMode={this.state.editMode}
        disabled={this.props.editMode}
        error={this.state.error}
        locale={this.locale}
        currency={this.currency}
        changeKondition={this.changeKondition}
        onKeyPress={this.onKeyPress}
        handleEdit={this.handleEdit}
        handleUndo={this.handleUndo}
        handleCommit={this.handleCommit}
        readOnly={this.props.readOnly}
      />
      <Preis preis={item.preis} kondition={kondition} mwst={item.mwst} />
      <Kurs kurs={item.kurs} kondition={kondition} />
    </>;
  }
}

export default connect(store => {
  return {
    configStorage: store.configStorage,
    konditionenStorage: store.konditionenStorage,
  };
})(ConditionsItem);
